import moment from "moment";

// recommended_arrival_time adalah waktu persis hasil hitungan backend
// (Asia/Makassar), bukan rentang 30 menit. Backend mengirimnya sebagai Carbon
// date-cast, jadi API-nya selalu ISO 8601 UTC (mis. "...T01:30:00.000000Z"
// untuk 09:30 WITA) - BUKAN string polos seperti dulu didokumentasikan di
// sini. Memberi format eksplisit non-ISO ke moment() membuatnya membaca
// angka UTC itu seolah sudah waktu lokal (selisih 8 jam, sering sudah lewat
// sehingga sepertinya "tidak pernah muncul"). moment(time) tanpa format
// mendeteksi ISO 8601 sendiri dan otomatis mengonversi ke zona lokal browser.
export const formatRecommendedArrival = (time) => {
  if (!time) return "-";
  const parsed = moment(time);
  return parsed.isValid() ? parsed.format("HH:mm") : "-";
};
